import { baseUrls } from '../../../constants/urls';
import { INBOUND_INSTRUCTION_TYPES } from '../../../domain/InstructionType';
import { CashMovementActivity } from '../../../types/request';

export const getCashMovementActivityTypeLabel = (activity: CashMovementActivity) => {
    if (activity.activityType === 'Receipt') return 'Receipt';
    return INBOUND_INSTRUCTION_TYPES.includes(activity.paymentRequest.instructionTypeCode)
        ? 'ACH Pull'
        : 'Withdrawal';
};

export const getCashMovementActivityDetailPath = (activity: CashMovementActivity) =>
    activity.activityType === 'PaymentRequest'
        ? `${baseUrls.cashMovementRequests}/${activity.reference}`
        : `${baseUrls.cashMovementRequests}/${encodeURIComponent(activity.reference)}?accountNumber=${encodeURIComponent(activity.accountNumber)}`;

export const getLatestRequestPath = (url?: string | null) => {
    if (!url) return undefined;
    const parts = url.split('support');
    return parts[parts.length - 1];
};
